<template>
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Reenviar" : "Cadastrar" }} Notificação
          </div>
        </v-toolbar>
        <div class="container dialog mt-7" >
          <v-form ref="form" v-if="visible">
            <v-row>
                <v-col cols="6">
                    <v-text-field
                    v-model="content.assunto"
                    label="Assunto da Notificação*"
                    maxLength="40"
                    counter="40"
                    dense
                    outlined
                    :rules="[(v) => $required(v), (v) => $max(v, 40)]"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-textarea
                    v-model="content.notificacao"
                    label="Notificação*"
                    maxlength="500"
                    counter="500"
                    rows="3"
                    dense
                    outlined
                    :rules="[(v) => $required(v), (v) => $max(v, 500)]"
                    ></v-textarea>
                </v-col>
                <v-col :cols="12">
                    <v-select
                    v-model="content.grupos"
                    item-text="nome"
                    item-value="id"
                    label="Grupo(s)*"
                    dense
                    outlined
                    multiple
                    return-object
                    :items="form.lists.grupos"
                    :rules="[(v) => $required(v)]"
                    ></v-select>
                </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          :actionText=" this.edit ? 'Reenviar': 'Enviar'"
          @click="salvar()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Grupo } from '~/commons/classes/grupo';
import ManterGrupoService from '@/services/manter-grupo.service';
import ManterGrupoNotificacaoService from '@/services/manter-grupo-notificacao.service';

import { GrupoNotificacao } from '~/commons/classes/grupo-notificacao';

export default {
  props: new DialogProps(Grupo),
  mixins: [
    ManterGrupoService,
    ManterGrupoNotificacaoService
  ],
  data: () => ({
    form: {
      lists: {
        grupos: [],
      }
    },
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = new GrupoNotificacao(this.content).formatParaEnviar();
          return this.$cadastrarGrupoNotificacao(payload);
        });
      };

      if (this.$validarFormulario("Preencha todos os campos obrigatórios!")) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
  mounted() {
    this.$buscarGrupos({ params: {situacao: true} }).then(({ data }) => this.form.lists.grupos = data.lista)
  }
}
</script>